import { sanitizeUrl } from '../../../../utils';
import { adaptEventHandler } from '../../../utils';

/**
 * Type for link button had to be defined here because the prop `href` should only take strings here
 * and not custom RouterLinkConfigs
 */

/**
 * Excluded props:
 * - analyticsContext - not supported in Forge
 * - interactionName - not supported in Forge
 * - iconAfter - not supported until Icon is introduced in UI Kit 2
 * - iconBefore - not supported until Icon is introduced in UI Kit 2
 * - UNSAFE_iconAfter_size - unsafe; ADS will remove it in the future
 * - UNSAFE_iconBefore_size - unsafe; ADS will remove it in the future
 */

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::8cbd042f3feb9099203d18858a3ab896>>
 * @codegenId #link-button
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen link-button
 * @codegenParams { "defineOwnType": true, "props": { "target": true, "href": { "value": "sanitizeUrl(href)", "comment": "safety measure " }, "rel": { "value": "'noopener noreferrer'", "comment": "safety measure", "excludeFromDeconstruct": true }, "children": true, "autoFocus": true, "overlay": false, "isDisabled": true, "isSelected": true, "onBlur": {"value": "adaptEventHandler(onBlur)"}, "onClick": {"value": "adaptEventHandler(onClick)"}, "onFocus": {"value": "adaptEventHandler(onFocus)"}, "spacing": true, "testId": true, "interactionName": false, "analyticsContext": false, "iconAfter": false, "UNSAFE_iconAfter_size": false, "iconBefore": false, "UNSAFE_iconBefore_size": false, "shouldFitContainer": true, "appearance": true } }
 * @codegenDependency ../../../../../../../design-system/button/src/new-button/variants/default/types.tsx <<SignedSource::8b826ec4e48d370688873f8bed0d2535>>
 * @codegenDependency ../../../../../../../design-system/button/src/new-button/variants/types.tsx <<SignedSource::07c6fecbf84091c424f884036f9ba2f6>>
 * @codegenDependency ../../../../../../../design-system/button/src/new-button/variants/default/link.tsx <<SignedSource::10ed95d93f452cfb5d46092c0eaa8639>>
 * @codegenDependency ../../../../../../../design-system/button/src/new-button/variants/default/use-default-button.tsx <<SignedSource::3777d59723581dee6a4017c59f587432>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import { LinkButton as PlatformLinkButton } from '@atlaskit/button/new';

// Define the type for LinkButton as LinkButtonProps at the top of this file

export var LinkButton = function LinkButton(props) {
  var _ref = props.forgeDoc.props,
    target = _ref.target,
    href = _ref.href,
    autoFocus = _ref.autoFocus,
    isDisabled = _ref.isDisabled,
    isSelected = _ref.isSelected,
    onBlur = _ref.onBlur,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    spacing = _ref.spacing,
    testId = _ref.testId,
    shouldFitContainer = _ref.shouldFitContainer,
    appearance = _ref.appearance;
  return /*#__PURE__*/React.createElement(PlatformLinkButton, {
    target: target
    // safety measure 
    ,
    href: sanitizeUrl(href)
    // safety measure
    ,
    rel: 'noopener noreferrer',
    children: props.forgeDoc.children.map(function (c) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: c.key
      }, props.render(c));
    }),
    autoFocus: autoFocus,
    isDisabled: isDisabled,
    isSelected: isSelected,
    onBlur: adaptEventHandler(onBlur),
    onClick: adaptEventHandler(onClick),
    onFocus: adaptEventHandler(onFocus),
    spacing: spacing,
    testId: testId,
    shouldFitContainer: shouldFitContainer,
    appearance: appearance
  });
};
/**
 * @codegenEnd
 */